"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.v1_Identify = v1_Identify;
var _identity = _interopRequireDefault(require("../identity.js"));
var _properties = require("./properties.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * DO NOT MODIFY
 * This file is generated by StashInvest/product-events
 * To open an issue, go to https://github.com/StashInvest/product-events/issues/new/choose
 */

function v1_Identify(payload) {
  const properties = new _properties.v1_IdentifyProperties(payload);
  const results = new _identity.default(properties).track();
  return {
    properties: results,
    context: properties.context()
  };
}
//# sourceMappingURL=identify_static_method.js.map